import {QueryCommand} from "xmgoing-server";
import SysConfigUtils from "@/utils/sysConfigUtils";
import {StorageUtils} from 'xmgoing-utils';
import GoingUtils from "@/utils/goingUtils";
import {usePageModelsStore} from "@/store/modules/pageModels";
import {storeToRefs} from "pinia";

export function useOpenSubPage(){
  /**
   * 加载界面设计信息
   * @param pageCode
   * @param moduleCode
   * @param backFun
   */
  const loadDesInfos=function ({pageCode,moduleCode},backFun){
    const pageConfigStrs=StorageUtils.getSessionItem(pageCode+"-"+moduleCode);
    if(pageConfigStrs){
      try {
        backFun&&backFun(JSON.parse(pageConfigStrs));
      }catch (e){
        StorageUtils.removeSessionItem(pageCode+"-"+moduleCode);
        loadDesInfos({pageCode,moduleCode},backFun);
      }
    }else{
      //获取界面id
      const queryCommand = new QueryCommand({
        showTip:false,
        method:"GET",
        url: SysConfigUtils.go_eplat_adress + '/api/go-lcc/customPage/getByModuleCodeAndPageCode'
      });
      //执行查询操作
      queryCommand.executeQuery({params:{pageCode,moduleCode}, successFun:(datas)=>{
          if(datas&&datas.infoSettingJson){
            try {
              backFun&&backFun(JSON.parse(datas.infoSettingJson));
            }catch (e){
            }
            StorageUtils.addSessionItem(pageCode+"_"+moduleCode,JSON.parse(datas.infoSettingJson));
          }else{
            backFun&&backFun({});
          }
        }});
    }
  };

  /**
   * 打开子界面
   * @param pageCode
   * @param moduleCode
   * @param winType
   * @param winWidth
   * @param winTitle
   */
  const openSubComPage=function (pageConfig){
    let {inParams={},selKey,pageCode,moduleCode,winType,winWidth,contentFrom,contentKey,winHeight,winTitle,cancelBtn,confirmBtn}=pageConfig;
    if(pageCode==null||pageCode===""){
      GoingUtils.showErrorMessage("部件界面编码缺失，请确认!");
      return;
    }
    if(!inParams){
      inParams={};
    }
    const params={...inParams};
    if(contentFrom==='userDef'){
      //打开自定义组件窗口
      if(winType==='user-def-win'){
        executeOpenWinEvent({...pageConfig,selKey,url:'',pageId:'',contentId:'', wTitle:winTitle, wWidth:winWidth, wHeight:winHeight,params,cancelBtn,confirmBtn,contentFrom,contentKey});
      }else{
        //打开自定义组件抽屉
        executeOpenDrawerEvent({...pageConfig,selKey,winWidth,winTitle,contentKey,params,contentFrom});
      }
    }else{
      if(winType==='user-def-win'){
        executeOpenWinEvent({...pageConfig,selKey,moduleCode,pageCode,url:'',pageId:'',contentId:'',
          wTitle:winTitle, wWidth:winWidth,
          wHeight:winHeight,params,cancelBtn,confirmBtn,
          contentFrom,contentKey});
      }else{
        //打开自定义组件抽屉
        executeOpenDrawerEvent({...pageConfig,selKey,moduleCode,winWidth,params,winTitle,contentKey,contentFrom,pageCode});
      }
    }
  }

  /**
   * 获取入口参数
   * @param argsAry
   */
  const getInParams=function (argsAry){
    const pageModelsStore: any = usePageModelsStore();
    const {state} = storeToRefs(pageModelsStore);
    const params={};
    if(argsAry&&Array.isArray(argsAry)){
      argsAry.forEach(({from, value,key})=>{
          if(from==="vuex"){
            params[key]=unref(state)[value];
          }
      })
    }
    return params
  }

  /**
   * 路由跳转
   * @param path
   */
  const openRouter=function ({path}){
    path=path.replace(/#{xm-vue-preview}/,"");
    path=path.replace("/login/#","");
    if(GoingUtils.getIsPreview()){
      window.appObj.$router.push({path});
    }else{
      GoingUtils.showMessage("方法执行成功，效果请在运行态进行验证！");
      return ;
    }
  }

  return {
    openRouter,
    getInParams,
    openSubComPage
  }
}
